/*
  Dadware sale deadline countdown.

  Counts down to an absolute timestamp rendered by snippets/dw-deadline.liquid.
  There is deliberately no duration option, no storage, and no restart path:
  every visitor sees the same remaining time against the same real end date,
  and when that date passes the element removes itself rather than looping.
*/
(function () {
  'use strict';

  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  function Countdown(el) {
    var ends = Date.parse(el.getAttribute('data-dw-ends'));
    if (!ends || isNaN(ends)) { el.remove(); return; }

    var h = el.querySelector('[data-dw-clock-h]');
    var m = el.querySelector('[data-dw-clock-m]');
    var s = el.querySelector('[data-dw-clock-s]');
    var clock = el.querySelector('[data-dw-clock]');
    var timer = null;
    var announced = false;

    function tick() {
      var left = ends - Date.now();

      if (left <= 0) {
        // The promotion is over. Remove the claim rather than leave a
        // zeroed clock or roll it forward.
        window.clearInterval(timer);
        el.remove();
        return;
      }

      var totalSeconds = Math.floor(left / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);

      // Announce once, not every second — a live region ticking per second is
      // unusable with a screen reader.
      if (clock && !announced) {
        clock.setAttribute('aria-label', hours + 'h ' + minutes + 'm remaining');
        announced = true;
      }
    }

    tick();
    if (h || m || s) timer = window.setInterval(tick, 1000);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-dw-deadline]').forEach(function (el) {
      if (el.dataset.dwDeadlineReady) return;
      el.dataset.dwDeadlineReady = '1';
      Countdown(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders a section without a full page load.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
